import React from "react";
import Link from "../../../shared/LinkTemplate/Link";

import ItemSlider from "../../../shared/ItemSlider/ItemSlider";
import ProductThumbnail from "../../../shared/ProductThumbnailTemplate/ProductThumbnail";
import Arrow from "../../../shared/Icons/Arrow";

import "./SpecialOffers.scss";

const SpecialOffers = (props) => {
  const ViewAllLink = ({ isTop = false }) => {
    return (
      <Link to="#" className={`link-view-all ${isTop ? "top" : "bottom"}`}>
        <span>Vedi tutte le offerte</span>
        {isTop && <Arrow />}
      </Link>
    );
  };

  return (
    <div className="container">
      <div className="special-offers">
        <ViewAllLink isTop />
        <ItemSlider
          loading={props.loading}
          title="Prodotti in sconto"
          primaryColor={props.primaryColor}
          uiVariant={props.uiVariantThumbnail}
        >
          {props.products.map((product) => {
            return (
              <ProductThumbnail
                key={product.id}
                product={product}
                list="Product slider"
              />
            );
          })}
        </ItemSlider>
        <ViewAllLink />
      </div>
    </div>
  );
};

export default SpecialOffers;
